import React from 'react';
import { BackgroundAuthentication } from 'page/Authentication/styled';
import {
  AuthSidebarPrivacy,
  BoxPrivacy,
  Container,
  ContainerPrivacy,
  FooterText,
  FooterWrapper,
  LogoPrivacy,
  TitlePrivacy,
} from 'page/Privacy/styled';
import useSetTitlePage from 'hook/useSetTitlePage';
import { Col, Row } from 'antd';
import Logo from 'components/Logo';
import { getPrivacyPolicy } from 'api/privacy/privacy.api';
import useCustomQuery from 'hook/useQuery/useCustomQuery';
import { HtmlRaw } from 'page/Application/ProjectRegistration/ProjectRegistrationDetail/styled';

const Privacy = () => {
  useSetTitlePage('個人情報の取り扱いについて', true);
  const { useQueryWithoutParams } = useCustomQuery();
  const { data: privacyData = [] } = useQueryWithoutParams({
    api: getPrivacyPolicy,
    key: 'privacyPolicy',
    options: {
      refetchOnWindowFocus: false, // cancel fetch data when out focus
    },
  });
  return (
    <BackgroundAuthentication className="background-authentication">
      <div className="container">
        <Row className="row">
          <Col xs={0} sm={0} md={0} lg={0} xl={11}>
            <AuthSidebarPrivacy>
              {/*<TextOnSidebarPrivacy>*/}
              {/*  <span>we are</span>*/}
              {/*  <br />*/}
              {/*  soliton*/}
              {/*</TextOnSidebarPrivacy>*/}
            </AuthSidebarPrivacy>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={13}>
            <Container>
              <LogoPrivacy>
                <Logo />
              </LogoPrivacy>
              <TitlePrivacy>
                個人情報の取り扱いについて
                <br />
                （必ずお読み下さい）
              </TitlePrivacy>
              <BoxPrivacy>
                <ContainerPrivacy>
                  <HtmlRaw
                    dangerouslySetInnerHTML={{
                      __html: privacyData?.data?.content,
                    }}
                  />
                </ContainerPrivacy>
              </BoxPrivacy>
              <FooterWrapper>
                <FooterText>
                  Copyright(C) Soliton Systems K.K., All rights reserved.
                </FooterText>
              </FooterWrapper>
            </Container>
          </Col>
        </Row>
      </div>
    </BackgroundAuthentication>
  );
};
export default Privacy;
